import { Link } from "react-router-dom";
import styled from "styled-components";
import NewFooter from "../../components/Footers/NewFooter";
import NewNavbar from "../../components/Navbar/NewNavbar";
import Seo from "../../components/Seo/Seo";
import { resources, resourcesByCluster } from "../../content/resources";
import { clusterList } from "../../content/resources/clusters";
import { resourcesIndexJsonLd } from "../../content/resources/schema";

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Hero = styled.section`
  padding: 120px 0 48px;
  background: #ffffff;
  text-align: center;
`;

const Wrap = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    font-size: 36px;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  line-height: 1.6;
  color: #4a4a4a;
  max-width: 680px;
  margin: 0 auto;
`;

const Body = styled.section`
  background: #f9fafb;
  padding: 48px 0 80px;
  flex: 1;
`;

const Cluster = styled.div`
  margin-bottom: 48px;
`;

const ClusterTitle = styled.h2`
  font-size: 26px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 6px;
`;

const ClusterDesc = styled.p`
  color: #6b7280;
  margin-bottom: 20px;
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const Card = styled(Link)`
  display: block;
  background: #fff;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  padding: 24px;
  text-decoration: none;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
    text-decoration: none;
  }
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
`;

const CardDesc = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
  margin: 0;
`;

const Empty = styled.p`
  text-align: center;
  color: #9ca3af;
`;

const ResourcesIndexPage = () => {
  const populatedClusters = clusterList
    .map((c) => ({ ...c, articles: resourcesByCluster(c.key) }))
    .filter((c) => c.articles.length > 0);

  return (
    <Page>
      <Seo
        title="Listino Resources — Listing Optimization Guides & Data"
        description="Guides and data on listing optimization, pricing, photos, and winning listings — for real estate agents and home sellers."
        path="/resources"
        jsonLd={resourcesIndexJsonLd(resources)}
      />
      <NewNavbar />

      <Hero>
        <Wrap>
          <Title>Resources</Title>
          <Subtitle>
            Practical guides and original data on pricing, photos, descriptions, and winning
            listings — for real estate agents and home sellers.
          </Subtitle>
        </Wrap>
      </Hero>

      <Body>
        <Wrap>
          {populatedClusters.length === 0 && <Empty>New guides are coming soon.</Empty>}
          {populatedClusters.map((cluster) => (
            <Cluster key={cluster.key}>
              <ClusterTitle>{cluster.name}</ClusterTitle>
              <ClusterDesc>{cluster.description}</ClusterDesc>
              <Cards>
                {cluster.articles.map((/** @type {any} */ a) => (
                  <Card key={a.slug} to={`/resources/${a.slug}`}>
                    <CardTitle>{a.title}</CardTitle>
                    <CardDesc>{a.description}</CardDesc>
                  </Card>
                ))}
              </Cards>
            </Cluster>
          ))}
        </Wrap>
      </Body>

      <NewFooter />
    </Page>
  );
};

export default ResourcesIndexPage;
